'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';

// import { Button } from '@/app/components/button';
import { Icon } from '@/app/components/icons';
import { SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/constants';
import loadingStyles from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/loading-guide/styles.module.css';
import type { SpartanProductExteriorThreesixtyStatusPhase } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/loading-guide/types';
import { SPARTAN_PRODUCT_EXTERIOR_TRACKING } from '@/app/lcv/components/sections/spartan/products/exterior/tracking';
import { SpartanProductExteriorInlineErrorIcon } from '@/app/lcv/components/sections/spartan/products/exterior-inline/threesixty/viewer/error-icon';
// import { SPARTAN_PRODUCT_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface SpartanProductExteriorInlineLoadingStatusProps {
  phase: SpartanProductExteriorThreesixtyStatusPhase | null;
  // onRetry: () => void;
  onExitComplete?: () => void;
}
export const SpartanProductExteriorInlineLoadingStatus = t0 => {
  const $ = _c(6);
  const {
    phase,
    onExitComplete
  } = t0;
  const shouldReduceMotion = useReducedMotion() ?? false;
  let t1;
  if ($[0] !== phase || $[1] !== shouldReduceMotion) {
    t1 = phase ? <motion.div key={phase} initial={{
      opacity: 0,
      scale: shouldReduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: shouldReduceMotion ? 1 : 0.96
    }} transition={{
      duration: shouldReduceMotion ? 0.1 : 0.2,
      ease: "easeOut"
    }} className={cn("pointer-events-none absolute inset-0 z-35 flex items-center justify-center", phase === "error" && "backdrop-blur-md")} {...createDataAttributes({
      test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyLoadingGuide
    })}><div role={phase === "error" ? "alert" : "status"} aria-live="polite" aria-label={phase === "loading" ? SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS.loading.replace(/<[^>]*>/g, "") : undefined} className={cn("flex size-39 items-center justify-center rounded-lg bg-black/50 text-white backdrop-blur-md lg:size-60", phase === "error" && "flex-col gap-3 px-3 lg:gap-4")} {...phase === "error" ? createDataAttributes({
        test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyLoadError
      }) : {}}>{phase === "loading" ? <span aria-hidden="true" className={cn("block size-10 rounded-full motion-safe:animate-spin lg:size-14", loadingStyles.spinner)} {...createDataAttributes({
          test: SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyLoading
        })} /> : <><Icon icon={<SpartanProductExteriorInlineErrorIcon />} size="xl" className="lg:size-14 [&_svg]:size-full" /><span className="text-body-2 max-w-32 text-center lg:max-w-44">โหลดภาพ 360°<br />ไม่สำเร็จ</span></>}</div></motion.div> : null;
    $[0] = phase;
    $[1] = shouldReduceMotion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onExitComplete || $[4] !== t1) {
    t2 = <AnimatePresence mode="wait" onExitComplete={onExitComplete}>{t1}</AnimatePresence>;
    $[3] = onExitComplete;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};